import { render, staticRenderFns } from "./PopUpByClientId.vue?vue&type=template&id=09226b4c&scoped=true"
import script from "./PopUpByClientId.vue?vue&type=script&lang=js"
export * from "./PopUpByClientId.vue?vue&type=script&lang=js"
import style0 from "./PopUpByClientId.vue?vue&type=style&index=0&id=09226b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09226b4c",
  null
  
)

export default component.exports